const USER_GROUPS = {
    ADMIN: 'GROUP_TAS_ADMIN',
    ELIMINERING: 'GROUP_TAS_ELIMINERING',
};

export default USER_GROUPS;
